import { FunctionComponent, useEffect } from "react";
import { FormikProps, useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import * as Yup from "yup";
import { updatePricing } from "../../Redux/Slicers/Pricing/UpdatePricingSlicer";
import { addPricing } from "../../Redux/Slicers/Pricing/AddPricingSlicer";
import TextInputField from "../../Components/TextInput/TextInputField";
import { Grid, Typography } from "@mui/material";
import TimePickers from "../../Components/TimePicker/TimePickers";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import ButtonField from "../../Components/Button/ButtonField";
import { IPricingList } from "./IPricing";
import Select from "../../Components/Select/Select";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { getSpaceTypes } from "../../Redux/Slicers/SpaceTypes/SpaceTypesSlicer";
interface MasterFormProps {
  TariffFrom: (data: FormikProps<any>) => void;
}

const TariffForm: FunctionComponent<MasterFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { pathname } = location;
  const pathnameParts = location.pathname.split("/");
  const id = pathnameParts[pathnameParts.length - 1];
  const { updateableDate } = useAppSelector((state) => state.UpdatePricing);
  const { data: projectData } = useAppSelector((state) => state.SpaceTypes);
  useEffect(() => {
    console.log("useE", updateableDate);
    console.log("projectData", projectData);
    dispatch(getSpaceTypes(id));
  }, []);

  // const projectData = getSpaceTypes;

  const isUpdateable =
    updateableDate && Object.keys(updateableDate).length !== 0;

  const formatTimeValue = (value?: string) => {
    if (!value) return "";
    const parsed =
      value.length > 5 ? dayjs(value) : dayjs(value, "HH:mm", true);
    return parsed.isValid() ? parsed.format("HH:mm") : "";
  };

  const initialValues = {
    name: updateableDate?.name || "",
    dayTimeStart: formatTimeValue(updateableDate?.dayTimeStart),
    dayTimeEnd: formatTimeValue(updateableDate?.dayTimeEnd),
    regularArea_HourlyRate: updateableDate?.regularArea?.hourlyRate || "",
    regularDayTimeCap: updateableDate?.regularArea?.dayTimeCap || "",
    regularNightTimeCap: updateableDate?.regularArea?.nightTimeCap || "",
    vipAreaHourlyRate: updateableDate?.vipArea?.hourlyRate || "",
    vipAreaDayTimeCap: updateableDate?.vipArea?.dayTimeCap || "",
    vipAreaNightTimeCap: updateableDate?.vipArea?.nightTimeCap || "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    // ...existing code...
  });

  const data1 = projectData?.response?.data;
  console.log("data", data1, projectData);

  const projects = Array.isArray(data1)
    ? data1.map((project) => ({
        label: project.name,
        value: project._id!,
      }))
    : [];

  console.log("projects", projects);

  const tariffFrom = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        dispatch(
          updatePricing({
            _id: updateableDate._id,
            location_id: id,
            name: values.name,
            dayTimeStart: values.dayTimeStart,
            dayTimeEnd: values.dayTimeEnd,
            structureUpdate: true,
          })
        );
      } else {
        const add = {
          name: values.name,
          dayTimeStart: values.dayTimeStart,
          dayTimeEnd: values.dayTimeEnd,
          location_id: id,
        };

        console.log("add", add);

        dispatch(addPricing(add));
      }
    },
  });

  return (
    <form
      className="master_form"
      onSubmit={tariffFrom.handleSubmit}
      onReset={tariffFrom.handleReset}
      autoComplete="off"
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextInputField
            id="name"
            name="name"
            label="Name"
            sx={{ width: "100%", marginBlock: "10px" }}
            value={tariffFrom.values.name}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={tariffFrom.touched.name && tariffFrom.errors.name}
            error={tariffFrom.touched.name && Boolean(tariffFrom.errors.name)}
          />
          {/* Space Type field removed */}
        </Grid>
        <Grid item xs={6}>
          <TimePickers
            label="Day time Start"
            value={
              tariffFrom.values.dayTimeStart
                ? dayjs(tariffFrom.values.dayTimeStart, "HH:mm")
                : null
            }
            ampm={false}
            onChange={(val) => {
              const formattedValue = dayjs(val).isValid()
                ? dayjs(val).format("HH:mm")
                : val;
              tariffFrom.setFieldValue("dayTimeStart", formattedValue);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TimePickers
            label="Day time End"
            value={
              tariffFrom.values.dayTimeEnd
                ? dayjs(tariffFrom.values.dayTimeEnd, "HH:mm")
                : null
            } // Use 'HH:mm' format for parsing
            ampm={false}
            onChange={(val) => {
              const formattedValue = dayjs(val).isValid()
                ? dayjs(val).format("HH:mm") // Keep the format as 'HH:mm'
                : val;
              tariffFrom.setFieldValue("dayTimeEnd", formattedValue); // Set the value directly as a string
            }}
          />
        </Grid>
        {/* <Grid
          item
          xs={6}>
          <TimePickers
            label="Day time Start"
            value={dayjs(tariffFrom.values.dayTimeStart, "HH:mm")}
            onChange={(val) => {
              const formattedValue = dayjs(val).isValid()
                ? dayjs(val).format("HH:mm")
                : val;
              tariffFrom.setFieldValue("dayTimeStart", formattedValue);
            }}
          />
        </Grid>

        <Grid
          item
          xs={6}>
          <TimePickers
            label="Day time End"
            value={dayjs(tariffFrom.values.dayTimeEnd, "HH:mm")} // Use 'HH:mm' format for parsing
            onChange={(val) => {
              const formattedValue = dayjs(val).isValid()
                ? dayjs(val).format("HH:mm") // Keep the format as 'HH:mm'
                : val;
              tariffFrom.setFieldValue("dayTimeEnd", formattedValue); // Set the value directly as a string
            }}
          />
        </Grid>

        <Grid
          item
          xs={6}>
          <Typography variant="caption">Area </Typography>
          <TextInputField
            id="regularArea_HourlyRate"
            name="regularArea_HourlyRate"
            label="Area Hourly Rate"
            sx={{ width: "100%" }}
            type="number"
            className="margin-bottom"
            value={tariffFrom.values.regularArea_HourlyRate}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.regularArea_HourlyRate &&
              tariffFrom.errors.regularArea_HourlyRate
            }
            error={
              tariffFrom.touched.regularArea_HourlyRate &&
              Boolean(tariffFrom.errors.regularArea_HourlyRate)
            }
          />
          <TextInputField
            id="regularDayTimeCap"
            name="regularDayTimeCap"
            label="Area Daytime Cap"
            type="number"
            sx={{ width: "100%" }}
            className="margin-bottom"
            value={tariffFrom.values.regularDayTimeCap}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.regularDayTimeCap &&
              tariffFrom.errors.regularDayTimeCap
            }
            error={
              tariffFrom.touched.regularDayTimeCap &&
              Boolean(tariffFrom.errors.regularDayTimeCap)
            }
          />
          <TextInputField
            id="regularNightTimeCap"
            name="regularNightTimeCap"
            label="Area Nighttime Cap"
            sx={{ width: "100%" }}
            type="number"
            value={tariffFrom.values.regularNightTimeCap}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.regularNightTimeCap &&
              tariffFrom.errors.regularNightTimeCap
            }
            error={
              tariffFrom.touched.regularNightTimeCap &&
              Boolean(tariffFrom.errors.regularNightTimeCap)
            }
          />
        </Grid> */}

        {/* <Grid
          item
          xs={6}>
          <Typography variant="caption">VIP Area </Typography>
          <TextInputField
            id="vipAreaHourlyRate"
            name="vipAreaHourlyRate"
            label="VIP Area Hourly Rate"
            type="number"
            sx={{ width: '100%' }}
            className="margin-bottom"
            value={tariffFrom.values.vipAreaHourlyRate}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.vipAreaHourlyRate &&
              tariffFrom.errors.vipAreaHourlyRate
            }
            error={
              tariffFrom.touched.vipAreaHourlyRate &&
              Boolean(tariffFrom.errors.vipAreaHourlyRate)
            }
          />
          <TextInputField
            id="vipAreaDayTimeCap"
            name="vipAreaDayTimeCap"
            label="VIP Area Daytime Cap"
            sx={{ width: '100%' }}
            type="number"
            className="margin-bottom"
            value={tariffFrom.values.vipAreaDayTimeCap}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.vipAreaDayTimeCap &&
              tariffFrom.errors.vipAreaDayTimeCap
            }
            error={
              tariffFrom.touched.vipAreaDayTimeCap &&
              Boolean(tariffFrom.errors.vipAreaDayTimeCap)
            }
          />
          <TextInputField
            id="vipAreaNightTimeCap"
            name="vipAreaNightTimeCap"
            label="VIP Area Nighttime Cap"
            sx={{ width: '100%' }}
            type="number"
            value={tariffFrom.values.vipAreaNightTimeCap}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.vipAreaNightTimeCap &&
              tariffFrom.errors.vipAreaNightTimeCap
            }
            error={
              tariffFrom.touched.vipAreaNightTimeCap &&
              Boolean(tariffFrom.errors.vipAreaNightTimeCap)
            }
          />
        </Grid> */}

        {/* <Grid
          item
          xs={12}>
        </Grid> */}
      </Grid>
      {/* <button
        type="submit"
        style={{ display: 'none' }}>
        Submit
      </button> */}
      <Grid container justifyContent="center" spacing={2} sx={{ mt: 3 }}>
        <Grid item>
          <ButtonField
            type="submit"
            sx={{ minWidth: 120 }}
            className="add_button"
          >
            {updateableDate ? "Update" : "Save"}
          </ButtonField>
        </Grid>
      </Grid>
    </form>
  );
};

export default TariffForm;
